import { useEffect, useRef } from 'react';

import { format } from 'date-fns';
import PropTypes from 'prop-types';

import { Tooltip } from '@mui/material';

import { inCurrentTimezone, parseEESeconds } from './utils';

import { TIMELINE_TOOLTIP_FORMAT } from './constants';

const TimelineValueLabelComponent = (props) => {
  const { children, value, open } = props;

  const popperRef = useRef(null);

  useEffect(() => {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });

  return (
    <Tooltip
      title={format(
        parseEESeconds(inCurrentTimezone(value)),
        TIMELINE_TOOLTIP_FORMAT,
      )}
      open={open}
      PopperProps={{ popperRef }}
      slotProps={{
        popper: {
          sx: {
            zIndex: 10,
            '&[data-popper-placement*="top"]': {
              '& > div': {
                top: '8rem !important',
              },
            },
          },
        },
        tooltip: {
          sx: (theme) => ({
            backgroundColor: 'transparent',
            color: theme.palette.text.primary,
            position: 'relative',
            top: '2rem',
            fontSize: '1.4rem',
          }),
        },
      }}
      placement="bottom"
    >
      {children}
    </Tooltip>
  );
};

TimelineValueLabelComponent.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
};

export default TimelineValueLabelComponent;
